import "./switch-button.scss";
function SwitchButton({ isActive }) {
  return (
    <div className="switch-button position-relative bg-secondary overflow-hidden rounded-3">
      {/* active Area */}
      <div
        className={`circle-container ${isActive} position-absolute rounded-3 bg-tertiary transition`}
      >
        <div className="circle bg-secondary rounded-circle" />
      </div>
    </div>
  );
}
export default SwitchButton;
